module.exports = __webpack_public_path__ + "src/img/cookies/cookies-blue-row-alt.6f82e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/cookies-blue-row-alt.jpg
// module id = 245
// module chunks = 0